import { useCallback } from "react";
import { useDispatch } from "react-redux";
import * as actions from "../../actions/cart/actions";

const useCartAction = () => {
    const dispatch = useDispatch();

    const setCartMessage = useCallback((message) => {
        dispatch(actions.setCartMessage(message));
    }, [dispatch]);

    const getCart = useCallback(() => {
        dispatch(actions.getCart());
    }, [dispatch]);

    const editCart = useCallback((payload) => {
        dispatch(actions.editCart(payload));
    }, [dispatch]);

    const clearLastAdded = useCallback(() => {
        dispatch(actions.clearLastAdded());
    }, [dispatch]);

    const clearCart = useCallback(() => {
        dispatch(actions.clearCart());
    }, [dispatch]);

    const ackCartRefresh = useCallback(() => {
        dispatch(actions.ackCartRefresh());
    }, [dispatch]);

    return {
        setCartMessage,
        getCart,
        editCart,
        clearLastAdded,
        clearCart,
        ackCartRefresh,
    };
};

export default useCartAction;